class CartSubscription {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-subscription-select]')) {
        this.handleSubscriptionChange(e.target);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('[data-subscription-select]')) {
        e.preventDefault();
        if (typeof e.target.showPicker === 'function') {
          e.target.showPicker();
        }
      }
    });
  }

  async handleSubscriptionChange(select) {
    const lineItemKey = select.dataset.lineItemKey;
    const selectedValue = select.value;

    // Guard: ignore the disabled placeholder (empty value)
    if (!lineItemKey || !selectedValue) return;

    const wrapper = select.closest('.cart__subscription-cta');
    if (wrapper) wrapper.classList.add('loading');

    try {
      if (selectedValue === 'onetime') {
        await this.removeSubscription(lineItemKey);
      } else {
        await this.addSubscription(lineItemKey, selectedValue);
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.getCart === 'function') {
        cartItems.getCart();
      }
    } catch (error) {
      console.error('Error updating subscription:', error);
      alert('Failed to update subscription. Please try again.');
    } finally {
      if (wrapper) wrapper.classList.remove('loading');
    }
  }

  async addSubscription(lineItemKey, sellingPlanId) {
    const escapedKey = lineItemKey.replace(/:/g, '\\:');
    const quantityInput = document.querySelector(`#updates_${escapedKey}`);
    const currentQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: currentQuantity, selling_plan: sellingPlanId })
    });

    let responseBody = null;
    try { responseBody = await response.json(); } catch (e) { throw new Error('Failed to parse cart response'); }

    if (!response.ok || (responseBody && responseBody.errors)) {
      const msg = responseBody?.errors || responseBody?.description || responseBody?.message || `Failed to add subscription (${response.status})`;
      throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    }
  }

  async removeSubscription(lineItemKey) {
    const escapedKey = lineItemKey.replace(/:/g, '\\:');
    const quantityInput = document.querySelector(`#updates_${escapedKey}`);
    const currentQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: currentQuantity, selling_plan: null })
    });

    let responseBody = null;
    try { responseBody = await response.json(); } catch (e) { throw new Error('Failed to parse cart response'); }

    if (!response.ok || (responseBody && responseBody.errors)) {
      const msg = responseBody?.errors || responseBody?.description || responseBody?.message || `Failed to remove subscription (${response.status})`;
      throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    }
  }
}

// Singleton — safe to initialise multiple times
let cartSubscriptionInstance = null;

function initCartSubscription() {
  if (!cartSubscriptionInstance) {
    cartSubscriptionInstance = new CartSubscription();
  }
}

document.addEventListener('DOMContentLoaded', initCartSubscription);
document.addEventListener('theme:cart:updated', initCartSubscription);
document.addEventListener('theme:cart-drawer:open', initCartSubscription);
